import { Flex, Space, Tag, Tooltip } from "antd";
import React, {useEffect, useState } from "react";
import {TextAreaActions} from "../../../../../../ai/components/TextAreaActions";
import {updateShot} from "../../../../../../feature/project/draftSlice";
import {useAppDispatch, useAppSelector} from "../../../../../../feature/tools";
import {DraftShot} from "../../../../../../feature/Draft";

export const PlotShotDetails = (props:{shot: DraftShot, id?: string}) => {
    const dispatch = useAppDispatch()
    const draft = useAppSelector(state => state.draftSlice.draft)
    const [description, setDescription] = useState<string>(props.shot.description ?? '')
    const [text, setText] = useState<string>(props.shot.narration.text ?? '')

    useEffect(() => {
        setDescription(props.shot.description ?? '')
    }, [props.shot.description]);

    useEffect(() => {
        setText(props.shot.narration.text ?? '')
    }, [props.shot.narration.text]);

    return (
        <Flex id={props.id} vertical={true} gap={10}>
            <TextAreaActions
                style={{border: "none"}}
                value={description}
                autoSize={true}
                validate={text => true}
                onChange={(text: string) => {
                    setDescription(text)
                    dispatch(updateShot({
                        // @ts-ignore
                        shot: {
                            ...props.shot,
                            description: text
                        }
                    }))
                }}
            />
            <Flex vertical={true} gap={10}
                  style={{background: "#eee", borderRadius: 6, padding: 10}}>
                <Flex>
                    <Tag>{props.shot.environment}</Tag>
                    <Tag>{props.shot.place}</Tag>
                    <Tag>{props.shot.time}</Tag>
                </Flex>
                <Flex gap={10}>
                    <div style={{background: "#111111", width: 4}}></div>
                    <div style={{flexGrow: 1}}>
                        <div>
                            <b>{props.shot.narration?.character} {props.shot.narration?.expression ? '(' + props.shot.narration.expression + ')' : ''}</b>
                        </div>

                        <TextAreaActions
                            style={{border: "none", background: 'none'}}
                            value={text}
                            autoSize={true}
                            validate={text => true}
                            onChange={(text: string) => {
                                setText(text)
                                dispatch(updateShot({
                                    // @ts-ignore
                                    shot: {
                                        ...props.shot,
                                        narration: {
                                            ...props.shot.narration,
                                            text: text
                                        }
                                    }
                                }))
                            }}
                        />
                    </div>
                </Flex>
                <Flex vertical={true} gap={10}>
                    {props.shot.choice?.map((choice, index) => <Tag style={{margin: 0}}
                                                              key={index}><Flex
                        justify={'space-between'}><span style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                    }}>{choice.title}</span><Tooltip title={<Space
                        direction={'vertical'}>{draft.story.lines.find((i) => i.id == choice.line)?.title ?? ''}{draft.story.lines.find((i) => i.id == choice.line)?.description ?? ''}</Space>}>{choice.line}</Tooltip></Flex></Tag>)}

                </Flex>
            </Flex>
        </Flex>
    );
}
